import { OrganizationCodes } from '@revenuemarket/bank';
import { AccountStatus } from '@revenuemarket/trade';

import { API } from '~apis/axios/instance';
import { BankAccount } from '~models/bank/bank';
import { AccountType } from '~models/bank/enum';
import { ResponseBaseWithData } from '~types/response';

/**
 * company 의 전체 계좌 조회 API
 * @link https://bank.dev.clobe.ai/swagger-ui/index.html#/Bank%20Account%20API/getBankAccounts
 *
 * @param companyId
 * @returns
 */
export default function getBankAccounts(companyId: string) {
  return API.get<
    ResponseBaseWithData<{
      accounts: BankAccount[];
    }>
  >(`/api/v2/companies/${companyId}/accounts`);
}

interface ICertificatesItem {
  /** id */
  id: number;
  /** 계좌id */
  accountId: number;
  /** 인증서 id */
  certificateId: number;
  /** 연결 id */
  connectedId: string;
}
interface AccountInfo {
  /** 계좌 id */
  bankAccountId: number;
  /** 회사 id */
  companyId: string;
  /** 계좌 번호 */
  accountNumber: string;
  /** 별칭  */
  aliasName: string;
  /** 은행 code */
  bankCode: OrganizationCodes;
  /** 대표계좌 존재 여부 */
  main: boolean;
  /** 집금 계좌 존재 여부 */
  collect: boolean;
  /** 동의? 여부 */
  agreement: boolean;
  /** over draft */
  overdraft: boolean;
  /** 표기용 계좌 번호 */
  displayAccountNumber: string;
  /**  계좌 타입 */
  accountType: AccountType;
  /** 추가 정보 */
  additionalInfo: string;
  /** 계좌 상태  */
  accountStatus: AccountStatus;
  /** 업데이트 일시 */
  updatedAt: string;
  /** 인증서 목록 */
  certificates: ICertificatesItem[];
  /** 정상여부 */
  normal: boolean;
  /** scrape target */
  scrapeTarget: boolean;
  /** 최대 scrape 기간 */
  maxScrapePeriod: number;
  /** 비정상 여부 */
  abnormal: boolean;
  /** 최대 scrape unit */
  maxScrapeUnit: string;
}

export interface MainAccountsResponse {
  account: AccountInfo;
}

/**
 * 대표 계좌 조회 API
 * @link https://apollo11.dev.clobe.ai/swagger-ui/index.html#/Bank%20Account%20API/getMainBankAccount
 * @param companyId
 * @returns
 */
export function getMainAccountInfo(companyId: string) {
  return API.get<ResponseBaseWithData<MainAccountsResponse>>(
    `/api/v2/companies/${companyId}/accounts/main`,
  );
}
